import moment from 'moment';

import store from 'store';

import { signOut, tokenRefreshRequest } from 'actions/auth/manager';
import { resetMenuList } from 'actions/common/menu';
import { resetAllHub } from 'actions/common/shopNotification';

import History from 'routes/history';

// Service to check authentication for user and to signOut
const Auth = {
    signOut() {
        console.log('signOut');
        // 연결된 모든 허브 끊기
        store.dispatch(resetAllHub());

        // 접근 가능한 메뉴 목록 초기화 
        store.dispatch(resetMenuList());

        // 로그아웃 처리
        store.dispatch(signOut());

        // 로그인 페이지로 이동
        History.push('/signin');
    },
    isAuth() {
        const manager = store.getState().manager;

        if(manager.token.accessToken === ''){
            return false;
        }
        else{
            console.log('==========================');
            console.log('now', moment().unix());
            console.log('expires', manager.token.expires);
            console.log(moment().unix() > manager.token.expires);
            if(moment().unix() > manager.token.expires) {
                console.log('access token 만료로 갱신 시도');

                // 토큰 재발급
                store.dispatch(tokenRefreshRequest());
            }
        }

        return true;
    }
};

export default Auth;
